var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 12.0002L14.6667 20.0002M14.6667 12.0002L22.6667 20.0002M3.62667 17.2802L9.38667 24.9602C9.856 25.5859 10.0907 25.8988 10.3881 26.1245C10.6515 26.3244 10.9498 26.4735 11.2677 26.5643C11.6267 26.6668 12.0178 26.6668 12.8 26.6668H22.9333C25.1735 26.6668 26.2937 26.6668 27.1493 26.2309C27.9019 25.8474 28.5139 25.2354 28.8974 24.4828C29.3333 23.6271 29.3333 22.507 29.3333 20.2668V11.7335C29.3333 9.49329 29.3333 8.37318 28.8974 7.51753C28.5139 6.76489 27.9019 6.15296 27.1493 5.76947C26.2937 5.3335 25.1735 5.3335 22.9333 5.3335H12.8C12.0178 5.3335 11.6267 5.3335 11.2677 5.43602C10.9498 5.52682 10.6515 5.67596 10.3881 5.87583C10.0907 6.1015 9.856 6.41439 9.38667 7.04016L3.62667 14.7202C3.28241 15.1792 3.11028 15.4087 3.04393 15.6607C2.98536 15.8832 2.98536 16.1171 3.04393 16.3396C3.11028 16.5916 3.28241 16.8212 3.62667 17.2802Z",
    stroke: "#6E56CF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.07308a38dc7aa5142d9bc7e13cbb7103.svg";
export { ForwardRef as ReactComponent };